<div class="td-wb-modal-notification">
  <h1 class="td-wb-modal-notification__header"
      translate="tdWb.modalNotification.fullyPaidLending.TITLE"></h1>
  <div class="td-wb-modal-notification__row">
    <div class="td-wb-modal-notification__left">
      <p class="td-wb-modal-notification__copy"
         translate="tdWb.modalNotification.fullyPaidLending.DESCRIPTION"></p>
      <div>
        <ul class="td-wb-ul td-wb-ul--basic td-wb-modal-notificiation__list">
          <li translate="tdWb.modalNotification.fullyPaidLending.DETAILS_I"></li>
          <li translate="tdWb.modalNotification.fullyPaidLending.DETAILS_II"></li>
          <li translate="tdWb.modalNotification.fullyPaidLending.DETAILS_III"></li>
        </ul>
      </div>
      <a class="td-wb-modal-notification__link"
         href="#/modal/fpl/enrollment"
         translate="tdWb.modalNotification.fullyPaidLending.LEARN_MORE"></a>
    </div>
    <div class="td-wb-modal-notification--image-container">
      <img tdWbModalNotificationImage
           width="280px"
           height="280px"
           src="fully-paid-lending.svg"
           [attr.alt]="'tdWb.modalNotification.fullyPaidLending.IMAGE_ALT' | translate"
      />
    </div>
  </div>
</div>
